import * as React from "react"
import { AlertCircle, Calendar, ExternalLink } from "lucide-react"
import { Alert, AlertDescription, AlertTitle } from "./alert"
import { ButtonWidget } from "./button-widget"
import { cn } from "../../lib/utils"

export interface ContentEntry {
  title: string
  description: string
  date: string
  link: string
  linkText?: string
}

interface BannerViewProps {
  entry: ContentEntry
  variant?: "default" | "destructive"
  className?: string
  showIcon?: boolean
}

const BannerView = React.forwardRef<HTMLDivElement, BannerViewProps>(
  ({ entry, variant = "default", className, showIcon = true, ...props }, ref) => {
    return (
      <Alert ref={ref} variant={variant} className={cn("dsw-relative", className)} {...props}>
        {showIcon && <AlertCircle className="dsw-h-4 dsw-w-4" />}
        <AlertTitle className="dsw-flex dsw-items-center dsw-gap-2 dsw-mb-2">
          {entry.title}
          <span className="dsw-flex dsw-items-center dsw-gap-1 dsw-text-xs dsw-text-muted-foreground dsw-font-normal">
            <Calendar className="dsw-h-3 dsw-w-3" />
            {entry.date}
          </span>
        </AlertTitle>
        <AlertDescription className="dsw-mb-4">
          {entry.description}
        </AlertDescription>
        {entry.link && (
          <ButtonWidget 
            variant="outline" 
            size="sm" 
            asChild
            className="dsw-absolute dsw-bottom-4 dsw-right-4"
          >
            <a href={entry.link} target="_blank" rel="noopener noreferrer" className="dsw-flex dsw-items-center">
              <ExternalLink className="dsw-h-3 dsw-w-3 dsw-mr-1" />
              {entry.linkText || "Learn More"}
            </a>
          </ButtonWidget>
        )}
      </Alert>
    )
  }
)
BannerView.displayName = "BannerView"

export { BannerView } 